import styled from 'styled-components';
import {Link} from 'react-router';

interface IActive {
    $active: boolean;
    $focused: boolean;
}

export const MenuLink = styled(Link)<IActive>`
    display: block;
    width: 16rem;
    color: #e9ecef;
    text-decoration: none;
    border-radius: 8px;
    transition: background-color 0.2s;

    background-color: ${(props) => {
        if (props.$active) return '#007bff';
        return 'transparent';
    }};

    border: ${(props) => (props.$focused ? '2px solid #0044ff' : '2px solid transparent')};

    &:hover {
        background-color: ${({$active}) => ($active ? '#346478' : '#2c2c2c')};
    }
`;

export const MenuItemContent = styled.div`
    display: grid;
    grid-template-columns: 50px 1fr;
    align-items: center;
    padding: 0.5rem 0;
`;

export const IconWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const LabelWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const Icon = styled.img<IActive>`
    width: 2.6rem;
    height: 2rem;
    filter: ${({$active}) => ($active ? 'brightness(0) invert(1)' : 'none')};
    opacity: ${(props) => (props.$active || props.$focused ? 1 : 0.7)};
    transition: opacity 0.2s ease;
`;

export const Label = styled.span<{$focused: boolean}>`
    font-size: 1.6rem;
    font-weight: ${(props) => (props.$focused ? '600' : '400')};
    color: #fff;
    transition: all 0.2s ease;
`;
